import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'wt-ui';
import UnderlyingBox from '../UnderlyingBox';

// hack - TO REMOVE AFTER TEST
/*
const a = new URLSearchParams(window.location.search);
const tmpFn = (param) => {
  const aux = param.split(',');
  return {
    r: Number(aux[0]),
    g: Number(aux[1]),
    b: Number(aux[2]),
  };
};
a.get('positive')
  ? {
    positive: tmpFn(a.get('positive')),
    neutral: tmpFn(a.get('neutral')),
    negative: tmpFn(a.get('negative')),
  }
  :
  positive: { r: 132, g: 189, b: 0 },
*/
const colors = {
  positive: { r: 101, g: 141, b: 27 },
  neutral: { r: 91, g: 103, b: 112 },
  negative: { r: 210, g: 38, b: 48 },
};

const getAlpha = (pct, percentColors) => {
  const range = 0.3;
  const min = percentColors[0].pct;
  const max = percentColors[2].pct;

  let res = 0;

  if (pct < 0) {
    res = (range * pct) / min;
  } else if (pct > 0) {
    res = (range * pct) / max;
  }

  return 0.7 + res;
};

const getColorForPercentage = (pct, percentColors) => {
  let i = 1;
  for (i; i < percentColors.length - 1; i += 1) {
    if (pct < percentColors[i].pct) {
      break;
    }
  }
  const lower = percentColors[i - 1];
  const upper = percentColors[i];
  const range = upper.pct - lower.pct;
  if (range === 0) {
    return {
      ...colors.neutral,
      a: getAlpha(pct, percentColors),
    };
  }
  const rangePct = (pct - lower.pct) / range;
  const pctLower = 1 - rangePct;
  const pctUpper = rangePct;
  const color = {
    r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
    g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
    b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper),
    a: getAlpha(pct, percentColors),
  };
  return color;
};
// assumes itemsArr[0] is top performance and itemsArr[itemsArr.length-1] lowest
const asignColorsToItems = (itemsArr) => {
  const auxArr = itemsArr.map((x) => x.chg);
  const max = Math.max(...auxArr);
  const min = Math.min(...auxArr);

  const percentColors = [
    { pct: min, color: colors.negative },
    { pct: 0, color: colors.neutral },
    { pct: max, color: colors.positive },
  ];
  return itemsArr.map((item) => ({
    ...item,
    color: getColorForPercentage(item.chg, percentColors),
  }));
};

const GroupView = (props) => {
  const { data, nColumns, blink } = props;

  const arr = asignColorsToItems(data.underlyingList);
  const responsiveGroup = [];
  while (arr.length > 0) {
    const chunck = arr.splice(0, nColumns);
    const children = chunck.map((u) => (
      <UnderlyingBox key={u.name} underlying={u} nColumns={nColumns} blink={blink.indexOf(u.name) >= 0} />
    ));
    responsiveGroup.push(
      <Box key={`key_${chunck.map((u) => u.name).join()}`} background="transparent" direction="row">
        {children}
      </Box>,
    );
  } // row-responsive on X width

  return (
    <>
      <Box pad="none" background="transparent">
        <h5 style={{ margin: '0px' }}>{data.name}</h5>
      </Box>
      <Box background="transparent">{responsiveGroup}</Box>
    </>
  );
};
GroupView.propTypes = {
  data: PropTypes.shape({}).isRequired,
  blink: PropTypes.arrayOf(PropTypes.string).isRequired,
  nColumns: PropTypes.number.isRequired,
};

export default GroupView;
